import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

export default function PdfPreview({ url }: { url: string }) {
  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);
  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }
  return (
    <Box
      sx={{
        width: "100%",
        aspectRatio: "16/9",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box mb={1}>
        <Document file={url} onLoadSuccess={onDocumentLoadSuccess} options={options}>
          <Page pageNumber={pageNumber} />
        </Document>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center" }}>
        Page {pageNumber} of {numPages}
      </Typography>
      <ButtonGroup>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setPageNumber(pageNumber - 1)}
          disabled={pageNumber === 1}
        >
          <ArrowBackIcon />
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setPageNumber(pageNumber + 1)}
          disabled={pageNumber === numPages}
        >
          <ArrowForwardIcon />
        </Button>
      </ButtonGroup>
    </Box>
  );
}
